import { combineReducers } from "redux";
import CancelServiceSlice from "./brotherPlus/cancelService/cancelServiceSlice";
import RegisterServiceSlice from "./brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice";
import getDevicesSlice from "./brotherPlus/getDevices/getDevicesSlice";
import getDeviceStatusSlice from "./brotherPlus/getDeviceStatus/getDeviceStatusSlice";
import getPrintHistorySlice from "./brotherPlus/getPrintHistory/getPrintHistorySlice";
import getUserPromoCodeSlice from "./brotherPlus/getUserPromoCode/getUserPromoCodeSlice";
import GetUserDeviceStatusSlice from "./CSAgentPortal/BrotherPlus/GetUserDeviceStatusSlice";
import GetUserPrintHistorySlice from "./CSAgentPortal/BrotherPlus/GetUserPrintHistorySlice";
import GetUserSubscriptionDetailsSlice from "./CSAgentPortal/BrotherPlus/GetUserSubscriptionDetailsSlice";
import validateUserPromoCodeSlice from "./brotherPlus/ValidateUserPromoCode/validateUserPromoCodeSlice";
import UpdateUserNotificationConsentStateSlice from "./brotherPlus/UserNotificationConsent/UpdateUserNotificationConsentStateSlice";
import getUserNotificationConsentDetailsSlice from "./brotherPlus/UserNotificationConsent/GetUserNotificationConsentDetailsSlice";
import brotherPlusPrintersSlice from "./brotherPlus/BrotherPlusPrinters/brotherPlusPrintersSlice";
import UpdateShippingAddressSlice from "./brotherPlus/UpdateShippingAddress/UpdateShippingAddressSlice"
import getNewDeveicePromoCodeSlice from "./brotherPlus/GetNewDevicePromoCode/getNewDevicePromoCodeSlice"
export default combineReducers({
    cancelService: CancelServiceSlice,
    RegisterService: RegisterServiceSlice,
    getDevices: getDevicesSlice,
    getDeviceStatus: getDeviceStatusSlice,
    getPrintHistory: getPrintHistorySlice,
    getUserPromoCode: getUserPromoCodeSlice,
    getUserDeviceStatus:GetUserDeviceStatusSlice,
    getUserPrintHistory:GetUserPrintHistorySlice,
    getUserSubscriptionDetails: GetUserSubscriptionDetailsSlice,
    validateUserPromoCode: validateUserPromoCodeSlice,
    updateUserNotificationConsentState:UpdateUserNotificationConsentStateSlice,
    getUserNotificationConsentDetails: getUserNotificationConsentDetailsSlice,
    brotherPlusPrinters: brotherPlusPrintersSlice,
    updateShippingAddressService: UpdateShippingAddressSlice,
    getNewDevicePromoCode:getNewDeveicePromoCodeSlice
})